/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NodataClientPackageItemResVo } from './NodataClientPackageItemResVo';
import {
    NodataClientPackageItemResVoFromJSON,
    NodataClientPackageItemResVoFromJSONTyped,
    NodataClientPackageItemResVoToJSON,
    NodataClientPackageItemResVoToJSONTyped,
} from './NodataClientPackageItemResVo';

/**
 * 
 * @export
 * @interface PageDataNodataClientPackageItemResVo
 */
export interface PageDataNodataClientPackageItemResVo {
    /**
     * 当前页
     * @type {number}
     * @memberof PageDataNodataClientPackageItemResVo
     */
    currentPage?: number;
    /**
     * 总页数
     * @type {number}
     * @memberof PageDataNodataClientPackageItemResVo
     */
    totalPage?: number;
    /**
     * 总记录数
     * @type {number}
     * @memberof PageDataNodataClientPackageItemResVo
     */
    totalRecord?: number;
    /**
     * 列表内容
     * @type {Array<NodataClientPackageItemResVo>}
     * @memberof PageDataNodataClientPackageItemResVo
     */
    records?: Array<NodataClientPackageItemResVo>;
}

/**
 * Check if a given object implements the PageDataNodataClientPackageItemResVo interface.
 */
export function instanceOfPageDataNodataClientPackageItemResVo(value: object): value is PageDataNodataClientPackageItemResVo {
    return true;
}

export function PageDataNodataClientPackageItemResVoFromJSON(json: any): PageDataNodataClientPackageItemResVo {
    return PageDataNodataClientPackageItemResVoFromJSONTyped(json, false);
}

export function PageDataNodataClientPackageItemResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageDataNodataClientPackageItemResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'totalPage': json['totalPage'] == null ? undefined : json['totalPage'],
        'totalRecord': json['totalRecord'] == null ? undefined : json['totalRecord'],
        'records': json['records'] == null ? undefined : ((json['records'] as Array<any>).map(NodataClientPackageItemResVoFromJSON)),
    };
}

export function PageDataNodataClientPackageItemResVoToJSON(json: any): PageDataNodataClientPackageItemResVo {
    return PageDataNodataClientPackageItemResVoToJSONTyped(json, false);
}

export function PageDataNodataClientPackageItemResVoToJSONTyped(value?: PageDataNodataClientPackageItemResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentPage': value['currentPage'],
        'totalPage': value['totalPage'],
        'totalRecord': value['totalRecord'],
        'records': value['records'] == null ? undefined : ((value['records'] as Array<any>).map(NodataClientPackageItemResVoToJSON)),
    };
}

